let cart;
function vueCart() {
    cart = Vue.createApp({
        delimiters: ['#{', '}'],
        setup() {
            const storeHistory = window.storeHistory();
            const collection = window.collectionStore();
            const cartTools = window.cartTools();
            const vehicleSearch = window.vehicleSearch();
            const promoStore = window.promo();
            const upsellAdded = Vue.ref([]);
            const rejectWA = Vue.ref([]);
            const mobileUpsellClosed = Vue.ref([]);
            const upsellLoading = Vue.ref([]);
            const noStoreTooltip = Vue.ref([]);
            const alignmentVideoOpen = Vue.ref([]);
            const toggleAlignmentVideo = (index) => {
                alignmentVideoOpen.value[index] = !alignmentVideoOpen.value[index];
            };

            storeHistory.addToHistory();
            collection.loadCache();
            cartTools.cartLoad();

            const fittingValid = Vue.computed(() => cartTools.cartContent.lines.edges.findIndex(line => line?.node?.merchandise?.product?.collections?.edges?.findIndex(edge => edge?.node?.type?.value === 'Buy 3 Get 4') > -1) > -1 ? false : true);

            const isWheel = Vue.computed(() => cartTools.cartContent.lines.edges.findIndex(line => line?.node?.merchandise?.product?.category?.name?.toLowerCase().includes('wheel')) > - 1 ? true : false);

            const freeArray = Vue.ref(["Balancing","Tyre Disposal","Tubeless Valves","Australia-Wide Warranty"])

            const storeSelector = window.storeSelector();
            const stockStore = window.stock();

            const storeVersioning = async () => {
                let updates
                let currentNearestStore = storeSelector.nearestStore;
                if (!currentNearestStore) {
                    try {
                        currentNearestStore = JSON.parse(localStorage.getItem('currentNearestStore'));
                    } catch (e) {
                        return;
                    }
                }
                let currentUserLocation = storeSelector.location;
                if (!currentUserLocation) {
                    try {
                        currentUserLocation = JSON.parse(localStorage.getItem('currentUserLocation'))
                    } catch (e) {
                        currentUserLocation = {
                            name: currentNearestStore.node.name,
                            latitude: currentNearestStore.node.address.latitude,
                            longitude: currentNearestStore.node.address.longitude
                        }
                        storeSelector.location = currentUserLocation;
                        localStorage.setItem('currentUserLocation', JSON.stringify(currentUserLocation));
                        if (localStorage.getItem(btoa('user'))) {
                            const customerTools = window.customerTools();
                            const submission = {
                                currentUserLocation: {
                                    siteData: currentUserLocation,
                                    updated: Date.parse(new Date())
                                }
                            }
                            customerTools.customerSubmission(submission, localStorage.getItem(btoa('user')));
                        }
                        updates = localStorage.getItem('updates');
                        if (updates) {
                            try {
                                let parsed = JSON.parse(updates);
                                parsed['currentUserLocation'] = Date.parse(new Date());
                                localStorage.setItem('updates', JSON.stringify(parsed));
                            } catch (error) {
                                localStorage.removeItem('updates');
                                console.error(`Error retrieving update times: ${error}`)
                            }
                        }
                        updates = false;
                    }
                }
                let locationsArray = await storeSelector.nearestLocation(currentUserLocation.latitude, currentUserLocation.longitude);
                let idx = locationsArray.findIndex(loc => loc.node.id == currentNearestStore.node.id)
                if (idx > -1) {
                    storeSelector.nearestStore = locationsArray[idx];
                    localStorage.setItem('currentNearestStore', JSON.stringify(locationsArray[idx]));
                    if (localStorage.getItem(btoa('user'))) {
                        const customerTools = window.customerTools();
                        const submission = {
                            currentNearestStore: {
                                siteData: locationsArray[idx],
                                updated: Date.parse(new Date())
                            }
                        }
                        customerTools.customerSubmission(submission, localStorage.getItem(btoa('user')));
                    }
                    updates = localStorage.getItem('updates');
                    if (updates) {
                        try {
                            let parsed = JSON.parse(updates);
                            parsed['currentNearestStore'] = Date.parse(new Date());
                            localStorage.setItem('updates', JSON.stringify(parsed));
                        } catch (error) {
                            localStorage.removeItem('updates');
                            console.error(`Error retrieving update times: ${error}`)
                        }
                    }
                    updates = false;
                    storeSelector.storesWithinDistance = locationsArray.filter(loc => loc.distance < shopifyConfig.storeRadius);
                    localStorage.setItem('storesUnder100', JSON.stringify(storeSelector.storesWithinDistance));
                    if (localStorage.getItem(btoa('user'))) {
                        const customerTools = window.customerTools();
                        const submission = {
                            storesUnder100: {
                                siteData: storeSelector.storesWithinDistance,
                                updated: Date.parse(new Date())
                            }
                        }
                        customerTools.customerSubmission(submission, localStorage.getItem(btoa('user')));
                    }
                    updates = localStorage.getItem('updates');
                    if (updates) {
                        try {
                            let parsed = JSON.parse(updates);
                            parsed['storesUnder100'] = Date.parse(new Date());
                            localStorage.setItem('updates', JSON.stringify(parsed));
                        } catch (error) {
                            localStorage.removeItem('updates');
                            console.error(`Error retrieving update times: ${error}`)
                        }
                    }
                }
                document.removeEventListener("contentReload", storeVersioning)
                return;
            }

            document.addEventListener("contentReload", storeVersioning)

            const selectedStoreName = Vue.computed(() => {
                const store = storeSelector?.nearestStore?.node || storeSelector?.nearestStore || null;
                return store?.name || null;
            });

            const { cartContent, showCart } = Pinia.storeToRefs(cartTools);

            const promoLoadingMap = Vue.reactive({});
            const lastUpdatedLineId = Vue.ref(null);
            const upsellProduct = Vue.ref([]);

            const cartContentValue = Vue.computed(() => cartContent.value?.value ?? cartContent.value);

            const cartLinesFiltered = Vue.computed(() => {
                const edges = cartContentValue.value?.lines?.edges || [];

                if (!Array.isArray(edges)) return [];

                const merged = new Map();
                edges.forEach((edge) => {
                    const node = edge?.node;
                    if (!node || (node.quantity || 0) <= 0) return;

                    const merchId = node?.merchandise?.id || node?.merchandise?.sku || node?.id;
                    if (!merchId) return;

                    const priceAmount = Number(node?.merchandise?.price?.amount || 0);
                    const totalPrice = node?.totalPrice || '';
                    const isFreeLine = priceAmount === 0 || totalPrice.includes('$0');
                    const lineSubtotal = Number(node?.cost?.subtotalAmount?.amount || 0);
                    const lineTotal = Number(node?.cost?.totalAmount?.amount || 0);
                    const isFitmentFee = node?.merchandise?.id === `gid://shopify/ProductVariant/${shopifyConfig.fitmentFeeProd || ''}`;
                    const promoEdges = node?.merchandise?.product?.collections?.edges || [];
                    const promoMeta = promoEdges
                        .map((promoEdge) => {
                            const type = promoEdge?.node?.type?.value || promoEdge?.node?.type || '';
                            const value = promoEdge?.node?.value?.value || promoEdge?.node?.value || '';
                            return { type: String(type), value: Number(value || 0) };
                        })
                        .find((entry) => entry.type);
                    const promoType = promoMeta?.type || '';
                    const promoValue = promoMeta?.value || 0;
                    const hasBuy3Get4Promo = promoType === 'Buy 3 Get 4' || promoType === 'Buy 3 Get 1';

                    if (!merged.has(merchId)) {
                        merged.set(merchId, {
                            edge,
                            qty: 0,
                            hasFree: false,
                            lineIds: [],
                            subtotal: 0,
                            total: 0,
                            unitPrice: 0,
                            hasBuy3Get4Promo: false,
                            promoType: '',
                            promoValue: 0,
                            isFitmentFee: false
                        });
                    }

                    const entry = merged.get(merchId);
                    entry.qty += node.quantity || 0;
                    if (isFreeLine) entry.hasFree = true;
                    if (node?.id) entry.lineIds.push(node.id);
                    entry.subtotal += lineSubtotal;
                    entry.total += lineTotal;
                    if (!entry.unitPrice && priceAmount > 0) entry.unitPrice = priceAmount;
                    entry.hasBuy3Get4Promo = entry.hasBuy3Get4Promo || hasBuy3Get4Promo;
                    if (!entry.promoType && promoType) {
                        entry.promoType = promoType;
                        entry.promoValue = promoValue;
                    }
                    entry.isFitmentFee = entry.isFitmentFee || isFitmentFee;
                });

                return Array.from(merged.values()).map(({ edge, qty, hasFree, lineIds, subtotal, total, unitPrice, hasBuy3Get4Promo, promoType, promoValue, isFitmentFee }) => {
                    let displayTotal = total;
                    if (hasBuy3Get4Promo && !isFitmentFee && unitPrice > 0) {
                        const freeUnits = Math.floor(Number(qty || 0) / 4);
                        displayTotal = Math.max(0, (Number(qty || 0) - freeUnits) * unitPrice);
                    } else if (!isFitmentFee && unitPrice > 0 && Number(qty || 0) >= 4) {
                        const promoSets = Math.floor(Number(qty || 0) / 4);
                        if (promoType === 'Cash Back' && promoValue > 0) {
                            const discountAmount = promoSets * promoValue;
                            displayTotal = Math.max(0, Number(qty || 0) * unitPrice - discountAmount);
                        } else if (promoType === 'Percentage' && promoValue > 0) {
                            const discountAmount = promoSets * (4 * unitPrice * (promoValue / 100));
                            displayTotal = Math.max(0, Number(qty || 0) * unitPrice - discountAmount);
                        }
                    }
                    const showDiscountPrice = Number(displayTotal || 0) < Number(subtotal || 0);
                    return ({
                        ...edge,
                        node: {
                            ...edge.node,
                            quantity: qty,
                            totalPrice: cartFormat(subtotal),
                            discountPrice: cartFormat(displayTotal),
                            _showDiscountPrice: showDiscountPrice,
                            _hasFreeLine: hasFree,
                            _lineIds: lineIds,
                        },
                    })
                });
            });

            const cartStockMap = Vue.reactive({});
            const cartStockDays = Vue.reactive({});
            const cartStockAvailableDate = Vue.reactive({});
            const cartProductLocations = Vue.reactive({});
            const fitmentFeeVariantGid = `gid://shopify/ProductVariant/${shopifyConfig.fitmentFeeProd || ''}`;
            const isFitmentFeeLine = (line) => line?.node?.merchandise?.id === fitmentFeeVariantGid;
            const isServiceLine = (line) =>
                (line?.node?.merchandise?.product?.category.name || '').toLowerCase().includes('maintenance');
            const isExcludedFromStockCheck = (line) => isServiceLine(line) || isFitmentFeeLine(line);

            const getSelectedStoreId = () => {
                const nearest = storeSelector?.nearestStore?.value || storeSelector?.nearestStore || null;
                const node = nearest?.node || null;
                return node?.id?.replace('gid://shopify/Location/', '') || null;
            };
            const getSelectedStoreNode = () => {
                const nearest = storeSelector?.nearestStore?.value || storeSelector?.nearestStore || null;
                return nearest?.node || null;
            };
            const isSelectedStoreClosed = Vue.computed(() => storeSelector.isLocationClosed(getSelectedStoreNode()));
            const selectedStoreClosedToDisplay = Vue.computed(() => storeSelector.formatClosedToDate(getSelectedStoreNode()?.closedTo));
            const isSelectedStoreBlockedDate = (dateStr) => storeSelector.isLocationClosed(getSelectedStoreNode(), dateStr);

            // Freight disclaimer: wheels bought in less than a full set of 4 may incur freight charges
            const wheelQtyInCart = Vue.computed(() => {
                return cartLinesFiltered.value.reduce((sum, line) => {
                    const categoryName = String(line?.node?.merchandise?.product?.category?.name || '').toLowerCase();
                    if (!categoryName.includes('wheel')) return sum;
                    return sum + (line?.node?.quantity || 0);
                }, 0);
            });
            const showWheelFreightNotice = Vue.computed(() => wheelQtyInCart.value > 0 && wheelQtyInCart.value < 4);

            const earliestFitmentDate = Vue.computed(() => {
                const productIds = cartLinesFiltered.value
                    .filter((line) => !isExcludedFromStockCheck(line))
                    .map((line) => line?.node?.merchandise?.product?.id?.replace('gid://shopify/Product/', ''))
                    .filter(Boolean);

                if (!productIds.length) return null;

                let maxDays = 0;
                for (const productId of productIds) {
                    const status = cartStockMap[productId];
                    if (!status || status === 'loading') return null;
                    if (status === 'outOfStock') return null;
                    const days = cartStockDays[productId] || 0;
                    maxDays = Math.max(maxDays, days);
                }

                const date = new Date();
                date.setDate(date.getDate() + maxDays);
                return date.toISOString().split('T')[0];
            });

            const toLocalISODate = (date = new Date()) => {
                const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
                return local.toISOString().split('T')[0];
            };

            const formatHHMM = (date) => `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;


            const BH_OPEN = 8 * 60;
            const BH_CLOSE_WD = 16 * 60;
            const BH_CLOSE_SAT = 13 * 60;
            const bhClose = (d) => d.getDay() === 6 ? BH_CLOSE_SAT : BH_CLOSE_WD;
            const bhIsOpen = (d) => d.getDay() !== 0;
            const bhNextOpenDay = (d) => {
                const next = new Date(d);
                do { next.setDate(next.getDate() + 1); } while (!bhIsOpen(next));
                next.setHours(8, 0, 0, 0);
                return next;
            };

            const allStockableProductsInStock = Vue.computed(() => {
                const productIds = cartLinesFiltered.value
                    .filter((line) => !isExcludedFromStockCheck(line))
                    .map((line) => line?.node?.merchandise?.product?.id?.replace('gid://shopify/Product/', ''))
                    .filter(Boolean);
                if (!productIds.length) return false;
                for (const productId of productIds) {
                    const status = cartStockMap[productId];
                    if (status === 'inStock') continue;
                    if (status === 'available' && Number(cartStockDays[productId]) === 1) continue;
                    return false;
                }
                return true;
            });

            const leadTimeNowTick = Vue.ref(Date.now());
            let leadTimeTimer = null;
            Vue.onMounted(() => {
                leadTimeTimer = setInterval(() => { leadTimeNowTick.value = Date.now(); }, 60000);
            });
            Vue.onBeforeUnmount(() => {
                if (leadTimeTimer) clearInterval(leadTimeTimer);
                leadTimeTimer = null;
            });


            const latestAvailableDate = Vue.computed(() => {

                void leadTimeNowTick.value;
                const productIds = cartLinesFiltered.value
                    .filter((line) => !isExcludedFromStockCheck(line))
                    .map((line) => line?.node?.merchandise?.product?.id?.replace('gid://shopify/Product/', ''))
                    .filter(Boolean);
                if (!productIds.length) return null;

                let latest = null;
                for (const productId of productIds) {
                    const status = cartStockMap[productId];
                    if (!status || status === 'loading' || status === 'outOfStock') return null;
                    const iso = cartStockAvailableDate[productId];
                    if (!iso) continue;
                    const d = new Date(iso);
                    if (isNaN(d.getTime())) continue;
                    if (!latest || d.getTime() > latest.getTime()) latest = d;
                }
                return latest;
            });

            const inStockLeadThreshold = Vue.computed(() => {
                const isPunctureOnly = cartLinesFiltered?.value?.length == 1
                    && cartLinesFiltered?.value[0]?.node?.merchandise?.product?.title?.toLowerCase().includes('puncture repair')
                    && storeSelector?.nearestStore?.node?.punctureRepair?.value?.toLowerCase() === "true";


                if (isPunctureOnly) {
                    const LEAD_MINUTES = shopifyConfig.defaultPunctureLead;
                    const SLOT = 30;

                    let d = new Date(leadTimeNowTick.value);
                    if (!bhIsOpen(d)) d = bhNextOpenDay(d);
                    const nowMins = d.getHours() * 60 + d.getMinutes();
                    if (nowMins < BH_OPEN) d.setHours(8, 0, 0, 0);
                    else if (nowMins >= bhClose(d)) d = bhNextOpenDay(d);

                    let remaining = LEAD_MINUTES;
                    while (remaining > 0) {
                        const currentMins = d.getHours() * 60 + d.getMinutes();
                        const available = bhClose(d) - currentMins;
                        if (available <= 0) { d = bhNextOpenDay(d); continue; }
                        const consume = Math.min(available, remaining);
                        d = new Date(d.getTime() + consume * 60000);
                        remaining -= consume;
                        if (remaining > 0) d = bhNextOpenDay(d);
                    }

                    const mins = d.getHours() * 60 + d.getMinutes();
                    const rounded = Math.ceil(mins / SLOT) * SLOT;
                    if (rounded > bhClose(d)) d = bhNextOpenDay(d);
                    else d.setHours(Math.floor(rounded / 60), rounded % 60, 0, 0);

                    return {
                        date: toLocalISODate(d),
                        time: formatHHMM(d),
                    };
                }


                const apiDate = latestAvailableDate.value;
                if (!apiDate) return null;

                const SLOT = 30;
                let d = new Date(apiDate.getTime());

                // Snap into business hours for its day
                if (!bhIsOpen(d)) d = bhNextOpenDay(d);
                const mins = d.getHours() * 60 + d.getMinutes();
                if (mins < BH_OPEN) {
                    d.setHours(8, 0, 0, 0);
                } else if (mins >= bhClose(d)) {
                    d = bhNextOpenDay(d);
                } else {
                    const rounded = Math.ceil(mins / SLOT) * SLOT;
                    if (rounded > bhClose(d)) {
                        d = bhNextOpenDay(d);
                    } else {
                        d.setHours(Math.floor(rounded / 60), rounded % 60, 0, 0);
                    }
                }

                return {
                    date: toLocalISODate(d),
                    time: formatHHMM(d),
                };
            });

            const minFitmentDate = Vue.computed(() => {
                const baseDate = earliestFitmentDate.value || toLocalISODate();
                const leadDate = inStockLeadThreshold.value?.date;
                if (!leadDate) return baseDate;
                return leadDate > baseDate ? leadDate : baseDate;
            });

            const isFitmentDateSunday = Vue.computed(() => {
                if (!cartTools.fitmentDate) return false;
                const d = new Date(cartTools.fitmentDate + 'T00:00:00');
                return d.getDay() === 0;
            });
            const isFitmentDateSaturday = Vue.computed(() => {
                if (!cartTools.fitmentDate) return false;
                const d = new Date(cartTools.fitmentDate + 'T00:00:00');
                return d.getDay() === 6;
            });

            const fitmentTimeOpen = '08:00';
            const fitmentTimeMin = Vue.computed(() => {
                const lead = inStockLeadThreshold.value;
                if (lead && lead.date === cartTools.fitmentDate && lead.time > fitmentTimeOpen) {
                    return lead.time;
                }
                return fitmentTimeOpen;
            });
            const fitmentTimeMax = '16:00';
            const fitmentTimeMaxSaturday = '13:00';
            const getFitmentTimeMaxForDate = (dateStr) => {
                if (!dateStr || !/^\d{4}-\d{2}-\d{2}$/.test(String(dateStr))) return fitmentTimeMax;
                const d = new Date(String(dateStr) + 'T00:00:00');
                return d.getDay() === 6 ? fitmentTimeMaxSaturday : fitmentTimeMax;
            };
            const currentFitmentTimeMax = Vue.computed(() => getFitmentTimeMaxForDate(cartTools.fitmentDate));
            const fitmentTimeRangeLabel = Vue.computed(() => {
                if (!cartTools.fitmentDate || isFitmentDateSunday.value) return '';
                const min = fitmentTimeMin.value;
                const max = getFitmentTimeMaxForDate(cartTools.fitmentDate);
                const fmt = (t) => {
                    const [hh, mm] = t.split(':').map(Number);
                    const suffix = hh >= 12 ? 'PM' : 'AM';
                    const h = ((hh + 11) % 12) + 1;
                    return `${h}:${String(mm).padStart(2, '0')} ${suffix}`;
                };
                return `Available ${fmt(min)} - ${fmt(max)}`;
            });
            const validDatePattern = /^\d{4}-\d{2}-\d{2}$/;
            const validTimePattern = /^\d{2}:\d{2}$/;

            const sanitizeFitmentValues = () => {
                const dateVal = cartTools.fitmentDate;
                const timeVal = cartTools.fitmentTime;
                const dateStr = typeof dateVal === 'string' ? dateVal.trim() : String(dateVal || '');
                const timeStr = typeof timeVal === 'string' ? timeVal.trim() : String(timeVal || '');

                if (!validDatePattern.test(dateStr)) {
                    if (cartTools.fitmentDate !== '') cartTools.fitmentDate = '';
                } else if (cartTools.fitmentDate !== dateStr) {
                    cartTools.fitmentDate = dateStr;
                }

                if (!validTimePattern.test(timeStr)) {
                    if (cartTools.fitmentTime !== '') cartTools.fitmentTime = '';
                } else if (cartTools.fitmentTime !== timeStr) {
                    cartTools.fitmentTime = timeStr;
                }
            };

            const getLocationIds = (primaryId) => {
                const ids = [primaryId];
                const pushLocation = (rawId) => {
                    const id = String(rawId || '').replace('gid://shopify/Location/', '').trim();
                    if (id && !ids.includes(id)) ids.push(id);
                };
                try {
                    const raw = localStorage.getItem('storesUnder100');
                    if (raw) {
                        const stores = JSON.parse(raw);
                        stores.forEach((edge) => {
                            const store = edge.node || edge;
                            const distance = parseFloat(edge?.distance ?? store?.distance ?? '0');
                            if (!Number.isFinite(distance) || distance <= 150) {
                                pushLocation(store?.id);
                            }
                        });
                    }
                } catch (e) { }
                if (ids.length === 1) {
                    let storeList = storeSelector?.storeList;
                    if (storeList && 'value' in storeList) storeList = storeList.value;
                    if (Array.isArray(storeList)) {
                        storeList.forEach((edge) => {
                            const store = edge?.node || edge;
                            pushLocation(store?.id);
                        });
                    }
                }
                return ids;
            };

            const checkCartStock = async () => {
                if (!stockStore || typeof stockStore.requestStock !== 'function') {

                    console.warn('[CartStock] No stock store found');
                    return;
                }

                const storeId = getSelectedStoreId();

                if (!storeId) {
                    console.warn('[CartStock] No storeId resolved — nearestStore may be null or missing id');
                    return;
                }

                const linesForStock = cartLinesFiltered.value || [];
                if (!linesForStock.length) return;

                const productQtyMap = {};
                linesForStock.forEach((line) => {
                    const productId = line?.node?.merchandise?.product?.id?.replace('gid://shopify/Product/', '');
                    const qty = Number(line?.node?.quantity || 0);
                    if (!productId) return;
                    if (isExcludedFromStockCheck(line)) {
                        // Mark as always in stock — no API check needed
                        cartStockMap[productId] = 'inStock';
                        return;
                    }
                    productQtyMap[productId] = (productQtyMap[productId] || 0) + qty;
                });

                const productIds = Object.keys(productQtyMap);
                if (!productIds.length) return;

                // Mark all as loading and clear stale location data
                productIds.forEach((id) => {
                    cartStockMap[id] = 'loading';
                    delete cartProductLocations[id];
                    delete cartStockAvailableDate[id];
                });

                const locationIds = getLocationIds(storeId);

                try {
                    // Chunk into groups of 4
                    const chunks = [];
                    for (let i = 0; i < productIds.length; i += 4) {
                        chunks.push(productIds.slice(i, i + 4));
                    }

                    for (const chunk of chunks) {
                        const uniqueQtys = [...new Set(chunk.map((id) => productQtyMap[id]))];

                        if (uniqueQtys.length === 1) {
                            const results = await stockStore.requestStock(chunk, locationIds, uniqueQtys[0]);
                            if (!Array.isArray(results)) continue;
                            applyStockResults(results, storeId);
                        } else {
                            for (const productId of chunk) {
                                const qty = productQtyMap[productId];
                                const results = await stockStore.requestStock([productId], locationIds, qty);
                                if (!Array.isArray(results)) continue;
                                applyStockResults(results, storeId);
                            }
                        }
                    }
                } catch (e) {
                    console.error('Cart stock check error:', e);
                    productIds.forEach((id) => {
                        delete cartStockMap[id];
                    });
                }
            };

            const genericStorageResult = (prodId) => {
                return cartProductLocations?.[prodId.replace('gid://shopify/Product/', '')]?.[0]?.genericStorage;
            }

            const applyStockResults = (results, storeId) => {
                const normalizeLocId = (id) => String(id || '').replace('gid://shopify/Location/', '');
                const normalizeAvailable = (value) => {
                    if (typeof value === 'boolean') return value;
                    const text = String(value || '').trim().toLowerCase();
                    return text === 'y' || text === 'yes' || text === 'true' || text === '1';
                };
                const normalizeDays = (value, fallback = 30) => {
                    const num = Number(value);
                    return Number.isFinite(num) && num >= 0 ? num : fallback;
                };
                const normalizedStoreId = normalizeLocId(storeId);


                results.forEach((result) => {
                    const productId = String(result.productGid);
                    const locations = result.locations || [];

                    // ── Persist full location data for cross-product alt-store search ──
                    cartProductLocations[productId] = locations.map((loc) => ({
                        locationGid: normalizeLocId(loc.locationGid),
                        available: normalizeAvailable(loc.available),
                        availableDays: normalizeDays(loc.availableDays, 30),
                        availableDate: loc.availableDate || null,
                        genericStorage: loc.genericStorage || false
                    }));


                    const locationStock = locations.find(
                        (loc) => normalizeLocId(loc.locationGid) === normalizedStoreId
                    );
                    const isAvailableAtStore = locationStock ? normalizeAvailable(locationStock.available) : false;
                    const availableDays = normalizeDays(locationStock?.availableDays, 0);
                    const availableDateIso = locationStock?.availableDate || null;

                    if (!locationStock || !isAvailableAtStore) {
                        cartStockMap[productId] = 'outOfStock';
                        delete cartStockDays[productId];
                        delete cartStockAvailableDate[productId];
                    } else if (availableDays === 0) {
                        cartStockMap[productId] = 'inStock';
                        delete cartStockDays[productId];
                        if (availableDateIso) {
                            cartStockAvailableDate[productId] = availableDateIso;
                        } else {
                            delete cartStockAvailableDate[productId];
                        }
                    } else {
                        cartStockMap[productId] = 'available';
                        cartStockDays[productId] = availableDays;
                        if (availableDateIso) {
                            cartStockAvailableDate[productId] = availableDateIso;
                        } else {
                            delete cartStockAvailableDate[productId];
                        }
                    }

                });
            };

            const lineStockStatus = (line) => {
                if (isFitmentFeeLine(line)) {
                    return {
                        status: 'alwaysAvailable',
                        days: null,
                    };
                }
                if (isServiceLine(line)) {
                    return {
                        status: 'storeAvailable',
                        days: null,
                    };
                }
                const productId = line?.node?.merchandise?.product?.id?.replace('gid://shopify/Product/', '');
                if (!productId) return null;
                return {
                    status: cartStockMap[productId] || null,
                    days: cartStockDays[productId] || null,
                };
            };

            const cartFormat = (number) => {
                const value = Number(number || 0);
                if (promoStore?.priceFormat) return promoStore.priceFormat(value);
                return new Intl.NumberFormat('en-AU', {
                    style: 'currency',
                    currency: 'AUD',
                }).format(value);
            }


            const getUpsellDescBubble = (upsell) => {
                if (!upsell?.alignment) return '';
                const clean = String(upsell?.description || '')
                    .replace(/<[^>]*>/g, ' ')
                    .replace(/&nbsp;/gi, ' ')
                    .replace(/\s+/g, ' ')
                    .trim();
                if (!clean) return '';
                const [first] = clean.split('.');
                return first?.trim() ? (clean.includes('.') ? `${first.trim()}.` : first.trim()) : '';
            };

            const fetchAlignmentDescriptionByVariant = async (variantGid) => {
                if (!variantGid) return '';

                try {
                    const res = await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP,
                        },
                        body: JSON.stringify({
                            query: `{ node(id:"${variantGid}") { ... on ProductVariant { product { description } } } }`,
                        }),
                    });
                    const data = await res.json();
                    return String(data?.data?.node?.product?.description || '');
                } catch {
                    return '';
                }
            };
            const bestAlternativeStore = Vue.computed(() => {
                const storeId = getSelectedStoreId();

                const normalizeLocId = (id) => String(id || '').replace('gid://shopify/Location/', '');

                const productIds = cartLinesFiltered.value
                    .filter((line) => !isExcludedFromStockCheck(line))
                    .map((line) => line?.node?.merchandise?.product?.id?.replace('gid://shopify/Product/', ''))
                    .filter(Boolean);


                // Don't compute until all products have location data
                const allLoaded = productIds.every(
                    (id) => Array.isArray(cartProductLocations[id]) && cartProductLocations[id].length > 0
                );

                const currentWorstDays = productIds.reduce((worst, id) => {
                    const loc = (cartProductLocations[id] || []).find(
                        (l) => l.locationGid === storeId
                    );
                    if (!loc || !loc.available) return 999;
                    return Math.max(worst, loc.availableDays);
                }, 0);

                let nearbyStores = [];
                try {
                    const raw = localStorage.getItem('storesUnder100');
                    if (raw) nearbyStores = JSON.parse(raw);
                } catch (e) {
                    console.warn('[CartStock] Failed to parse storesUnder100', e);
                }

                const candidates = nearbyStores
                    .map((edge) => {
                        const store = edge.node || edge;
                        const altId = normalizeLocId(store.id);

                        // Skip the current store
                        if (altId === storeId) return null;

                        // Check every product — store is disqualified if ANY product is
                        // unavailable there
                        let worstDays = 0;
                        for (const productId of productIds) {
                            const locData = (cartProductLocations[productId] || []).find(
                                (l) => l.locationGid === altId
                            );
                            if (!locData || !locData.available) {
                                return null;
                            }
                            worstDays = Math.max(worstDays, locData.availableDays);
                        }

                        // Only propose if genuinely better than the current store
                        if (worstDays >= currentWorstDays) {
                            return null;
                        }

                        const candidate = {
                            locationId: altId,
                            name: store.name,
                            distance: parseFloat(edge.distance || '0').toFixed(1),
                            availableDays: worstDays,
                            stockStatus: worstDays === 0 ? 'inStock' : 'available',
                        };
                        return candidate;
                    })
                    .filter(Boolean)
                    .sort((a, b) => {
                        if (a.availableDays !== b.availableDays) return a.availableDays - b.availableDays;
                        return parseFloat(a.distance) - parseFloat(b.distance);
                    });
            });


            const hasOutOfStockLines = Vue.computed(() =>
                cartLinesFiltered.value.some(
                    (line) => lineStockStatus(line)?.status === 'outOfStock'
                )
            );

            // ── switchCartStore ─────────────────────────────────────────────────
            const switchCartStore = (locationId) => {
                if (!storeSelector) return;

                let storeList = storeSelector.storeList;
                if (storeList && 'value' in storeList) storeList = storeList.value;

                const idx = Array.isArray(storeList)
                    ? storeList.findIndex((edge) => {
                        const id = (edge?.node?.id || edge?.id || '').replace('gid://shopify/Location/', '');
                        return id === locationId;
                    })
                    : -1;

                if (idx > -1) {
                    storeSelector.storeSelect(idx);
                } else {
                    try {
                        const raw = localStorage.getItem('storesUnder100');
                        if (raw) {
                            const stores = JSON.parse(raw);
                            const match = stores.find((edge) => {
                                const id = (edge?.node?.id || '').replace('gid://shopify/Location/', '');
                                return id === locationId;
                            });
                            if (match) {
                                storeSelector.updateNearestStore(match);
                                localStorage.setItem('currentNearestStore', JSON.stringify(match));
                                if (localStorage.getItem(btoa('user'))) {
                                    const customerTools = window.customerTools();
                                    const submission = {
                                        currentNearestStore: {
                                            siteData: match,
                                            updated: Date.parse(new Date())
                                        }
                                    }
                                    customerTools.customerSubmission(submission, localStorage.getItem(btoa('user')));
                                }
                                updates = localStorage.getItem('updates');
                                if (updates) {
                                    try {
                                        let parsed = JSON.parse(updates);
                                        parsed['currentNearestStore'] = Date.parse(new Date());
                                        localStorage.setItem('updates', JSON.stringify(parsed));
                                    } catch (error) {
                                        localStorage.removeItem('updates');
                                        console.error(`Error retrieving update times: ${error}`)
                                    }
                                }
                            }
                        }
                    } catch (e) { }
                }

                // Clear stale location data and re-check stock for the new store
                Object.keys(cartProductLocations).forEach((k) => {
                    delete cartProductLocations[k];
                });
                Object.keys(cartStockMap).forEach((k) => {
                    cartStockMap[k] = 'loading';
                });
                Object.keys(cartStockAvailableDate).forEach((k) => {
                    delete cartStockAvailableDate[k];
                });
                setTimeout(() => checkCartStock(), 400);
            };

            const enquireAll = () => {
                const outLines = cartLinesFiltered.value.filter(
                    (line) => lineStockStatus(line)?.status === 'outOfStock'
                );
                if (!outLines.length) return;
                const base = String(shopifyConfig?.storeURL || window.location.origin || '').replace(/\/$/, '');
                const page = shopifyConfig?.contactDefault ? String(shopifyConfig.contactDefault).replace(/^\//, '') : 'contact';
                window.location.href = `${base}/pages/${page}`;
            };

            // Show the "Order placed" celebration + confetti only when a product was just added
            const showOrderPlacedBanner = Vue.ref(false);
            let orderPlacedTimer = null;

            // Watch for cart opening — trigger stock check
            Vue.watch(
                () => cartTools.showCart,
                (isOpen) => {
                    if (isOpen) {
                        checkCartStock();
                        loadUpsellProduct();
                    } else {
                        showOrderPlacedBanner.value = false;
                        clearTimeout(orderPlacedTimer);
                    }
                }
            );

            // Promotes #cartTarget (this whole app's mount root - recoDrawer/
            // cartDrawer/preCheckDrawer all live inside it) into the browser's
            // top layer via the Popover API, manual mode. Purely a stacking
            // fix: a native modal <dialog> (e.g. the AI agent chat overlay's
            // own, or this theme's cart-drawer-component) always paints above
            // a plain positioned/z-indexed element, no matter how high its
            // z-index - so if this drawer opens while one of those is already
            // open, it could never win that fight as a plain div. Being a
            // popover puts it in the SAME contest as those, and whichever was
            // (re-)shown most recently wins - reported live: this drawer was
            // rendering behind the chat overlay when a cart action happened
            // mid-conversation. "manual" mode means the browser never
            // auto-dismisses it on outside click/Escape - every existing
            // close button/interaction here is unaffected, still entirely
            // driven by cartTools.showCart/openCheckout as before; this only
            // adds the imperative showPopover()/hidePopover() calls needed to
            // actually opt into that stacking behavior (a plain class toggle
            // alone doesn't promote anything to the top layer). Falls back to
            // exactly today's plain stacking on a browser without Popover API
            // support (guarded below), which is worse but not a regression.
            Vue.watch(
                () => cartTools.showCart || cartTools.openCheckout,
                (shouldShow) => {
                    const target = document.getElementById('cartTarget');
                    if (!target || typeof target.showPopover !== 'function') return;
                    if (shouldShow) {
                        if (!target.matches(':popover-open')) target.showPopover();
                    } else if (target.matches(':popover-open')) {
                        target.hidePopover();
                    }
                }
            );

            Vue.watch(
                () => cartTools.justAdded,
                (justAdded) => {
                    if (!justAdded) return;
                    const wasTyre = !!cartTools.justAddedIsTyre;
                    cartTools.justAdded = false;
                    cartTools.justAddedIsTyre = false;
                    if (!wasTyre) return;
                    showOrderPlacedBanner.value = true;
                    if (typeof window.fireCartConfetti === 'function') {
                        window.fireCartConfetti();
                    }
                    clearTimeout(orderPlacedTimer);
                    orderPlacedTimer = setTimeout(() => {
                        showOrderPlacedBanner.value = false;
                    }, 4000);
                }
            );
            const dismissOrderPlacedBanner = () => {
                showOrderPlacedBanner.value = false;
                clearTimeout(orderPlacedTimer);
            };

            Vue.watch(
                () => cartLinesFiltered.value
                    .map((line) => line?.node?.merchandise?.product?.id)
                    .filter(Boolean)
                    .join(','),
                () => {
                    if (cartTools.showCart) checkCartStock();
                }
            );

            // ── COMPUTED: Per-line promo info ──────────────────────────────────
            const linePromo = Vue.computed(() => (line) => {
                const lineId = line?.node?.id;
                const isLoading = lineId ? Boolean(promoLoadingMap[lineId]) : false;

                const alloc = (line?.node?.discountAllocations || []).find(
                    (a) => a?.discountApplication?.title || a?.discountApplication?.code
                );

                if (alloc?.discountApplication?.title || alloc?.discountApplication?.code) {
                    return {
                        message: alloc.discountApplication.title || alloc.discountApplication.code,
                        isLoading,
                    };
                }

                const edges = line?.node?.merchandise?.product?.collections?.edges || [];
                const promoEdge = edges.find((e) => e?.node?.title?.value || e?.node?.title);
                const promoTypeEdge = edges.find((e) => e?.node?.type?.value || e?.node?.type);

                const promoTitle = promoEdge?.node?.title?.value || promoEdge?.node?.title || '';
                const promoType = promoTypeEdge?.node?.type?.value || promoTypeEdge?.node?.type || '';

                if (promoType === 'Buy 3 Get 4' || promoType === 'Buy 3 Get 1') {
                    const qty = Number(line?.node?.quantity || 0);
                    const needed = 4 - qty;
                    if (needed > 0) {
                        return { message: `Add ${needed} to apply the promo`, isLoading };
                    }
                }

                return { message: promoTitle, isLoading };
            });

            const upsellKey = Vue.computed(() => `${cartTools.vehicleLPN || ''}|${cartTools.vehicleState || ''}`);

            const cartUpdating = Vue.ref(false);
            const priceUpdatePending = Vue.ref(false);
            let qtyDebounceTimer = null;
            let stockRecheckTimer = null;

            const hasBuy3Get4Promo = (line) => {
                const edges = line?.node?.merchandise?.product?.collections?.edges || [];
                return edges.some((edge) => {
                    const type = String(edge?.node?.type?.value || edge?.node?.type || '').trim().toLowerCase();
                    return type === 'buy 3 get 4' || type === 'buy 3 get 1';
                });
            };

            const hasActiveBuy3Get4Promo = Vue.computed(() => {
                const promoQty = (cartLinesFiltered.value || []).reduce((total, line) => {
                    if (!line?.node || isFitmentFeeLine(line)) return total;
                    if (!hasBuy3Get4Promo(line)) return total;
                    return total + Number(line?.node?.quantity || 0);
                }, 0);
                return promoQty >= 4;
            });

            const isFitmentRemovalLocked = (line) => {
                return isFitmentFeeLine(line) && hasActiveBuy3Get4Promo.value;
            };

            const canRemoveLine = (line) => {
                return !cartUpdating.value && !isFitmentRemovalLocked(line);
            };

            const isLinePriceUpdating = (line) => {
                if (!priceUpdatePending.value || !lastUpdatedLineId.value) return false;
                const lineIds = Array.isArray(line?.node?._lineIds) && line.node._lineIds.length > 0
                    ? line.node._lineIds
                    : [line?.node?.id].filter(Boolean);
                return lineIds.includes(lastUpdatedLineId.value);
            };

            const handleQtyChange = (line, delta, index) => {
                if (cartUpdating.value) return;
                if (isFitmentFeeLine(line)) return;

                const lineIds = Array.isArray(line?.node?._lineIds) && line.node._lineIds.length > 0
                    ? line.node._lineIds
                    : [line?.node?.id].filter(Boolean);
                if (!lineIds.length) return;

                const rawEdges = cartTools?.cartContent?.lines?.edges || [];
                const candidateEdges = rawEdges.filter((edge) => lineIds.includes(edge?.node?.id));
                if (!candidateEdges.length) return;

                const getLineAmount = (edge) =>
                    Number(edge?.node?.cost?.totalAmount?.amount ?? edge?.node?.cost?.subtotalAmount?.amount ?? 0);

                // Keep the paid/highest-value line as primary for promo-split products.
                const primaryEdge = [...candidateEdges].sort((a, b) => {
                    const amountDiff = getLineAmount(b) - getLineAmount(a);
                    if (amountDiff !== 0) return amountDiff;
                    return Number(b?.node?.quantity || 0) - Number(a?.node?.quantity || 0);
                })[0];

                const primaryLineId = primaryEdge?.node?.id || lineIds[0];
                const extraLineIds = lineIds.filter((id) => id !== primaryLineId);
                if (primaryLineId) lastUpdatedLineId.value = primaryLineId;

                const rawIndex = rawEdges.findIndex((edge) => edge?.node?.id === primaryLineId);
                if (rawIndex < 0) return;

                const displayedQty = candidateEdges.reduce((sum, edge) => sum + Number(edge?.node?.quantity || 0), 0);
                const nextQty = Math.max(1, displayedQty + delta);
                priceUpdatePending.value = true;
                if (extraLineIds.length === 0) {
                    cartTools.cartContent.lines.edges[rawIndex].node.quantity = nextQty;
                } else if (line?.node) {
                    // Avoid local merged-qty spikes while duplicate promo lines are being collapsed.
                    line.node.quantity = nextQty;
                }

                if (qtyDebounceTimer) clearTimeout(qtyDebounceTimer);

                qtyDebounceTimer = setTimeout(async () => {
                    cartUpdating.value = true;

                    const productId = line?.node?.merchandise?.product?.id?.replace('gid://shopify/Product/', '');
                    if (productId) {
                        cartStockMap[productId] = 'loading';
                        delete cartProductLocations[productId];
                    }

                    cartTools.pending = true;
                    const currentPaidQty = primaryEdge?.node?.quantity || 0;
                    const targetPaidQty = extraLineIds.length > 0
                        ? Math.max(1, currentPaidQty + delta)
                        : nextQty;
                    cartTools.cartContent.lines.edges[rawIndex].node.quantity = targetPaidQty;
                    await cartTools.cartUpdate(rawIndex);
                    console.log(fittingValid.value)
                    await checkCartStock();
                }, 1000);
            };

            const removeLine = async (index) => {
                const cartId = cartContentValue.value?.id;
                const displayedLine = cartLinesFiltered.value?.[index];
                if (!cartId || !displayedLine?.node) return;
                if (isFitmentRemovalLocked(displayedLine)) return;

                const lineIds = Array.isArray(displayedLine.node._lineIds) && displayedLine.node._lineIds.length > 0
                    ? displayedLine.node._lineIds
                    : [displayedLine.node.id].filter(Boolean);
                if (!lineIds.length) return;

                const productId = displayedLine?.node?.merchandise?.product?.id?.replace('gid://shopify/Product/', '');
                if (productId) {
                    delete cartStockMap[productId];
                    delete cartStockDays[productId];
                    delete cartStockAvailableDate[productId];
                    delete cartProductLocations[productId];
                }

                cartUpdating.value = true;
                try {
                    await cartTools.cartRemove(cartId, lineIds);
                } finally {
                    cartTools.pending = false;
                    cartUpdating.value = false;
                }
            };

            const loadUpsellProduct = async () => {
                try {
                    const raw = localStorage.getItem('vehicles');
                    if (!raw) return;
                    const vehicles = JSON.parse(raw);
                    const match = Array.isArray(vehicles) && vehicles.find((v) => v?.additions?.wa?.variantGid);
                    if (match?.additions?.wa) {
                        if (!String(match.additions.wa?.description || '').trim()) {
                            const fetchedDesc = await fetchAlignmentDescriptionByVariant(match.additions.wa.variantGid);
                            if (fetchedDesc) match.additions.wa.description = fetchedDesc;
                        }
                        if (upsellProduct?.value?.findIndex(val => val?.variantGid == match?.additions?.wa?.variantGid) == -1 && upsellProduct?.value?.length < 2) {
                            upsellProduct.value.push(match.additions.wa)
                            upsellAdded.value.push(false);
                            rejectWA.value.push(false);
                            mobileUpsellClosed.value.push(false);
                            upsellLoading.value.push(false);
                            noStoreTooltip.value.push(false);
                            alignmentVideoOpen.value.push(false);
                        }
                    }
                    if (shopifyConfig?.upsell?.active) {
                        if (!cartTools.cartContent) {
                            await cartTools.cartLoad()
                        }
                        if (upsellProduct?.value?.length < 2) {
                            let wheelIndex = cartTools?.cartContent?.lines?.edges.findIndex(edge => edge?.node?.merchandise?.product?.category?.name?.includes('heel'))
                            if (wheelIndex == -1) {
                                let tyreIndex = cartTools?.cartContent?.lines?.edges?.findIndex(edge => edge?.node?.merchandise?.product?.category?.name?.includes('ire') || edge?.node?.merchandise?.product?.category?.name?.includes('yre'))
                                if (tyreIndex > -1) {
                                    let match = cartTools?.cartContent?.lines?.edges[tyreIndex]?.node?.merchandise?.product?.metafield?.value;
                                    if (typeof match == 'string' && match.includes('_') && match.includes('R')) {
                                        match = match.split('_')[0].split('R')[1];
                                    } else {
                                        match = false;
                                    }
                                    if (match && vehicles[0]) {
                                        let wheelFitmentIndex = vehicles[0].fitmentInfo.wheel_fitments.findIndex(fit => fit.f_wheels.desc.split(' ')[0] == match);
                                        if (wheelFitmentIndex > -1) {
                                            if (vehicles[0].fitmentInfo.wheel_fitments[wheelFitmentIndex].f_wheels.matches.length > 0) {
                                                let stringFilters = ''
                                                for (i = 0; i < vehicles[0].fitmentInfo.wheel_fitments[wheelFitmentIndex].f_wheels.matches.length; i++) {
                                                    if (stringFilters == '') {
                                                        stringFilters = `{productMetafield:{namespace:"wts",key:"sf",value:"${vehicles[0].fitmentInfo.wheel_fitments[wheelFitmentIndex].f_wheels.matches[i]}"}}`
                                                    } else {
                                                        stringFilters = `${stringFilters},{productMetafield:{namespace:"wts",key:"sf",value:"${vehicles[0].fitmentInfo.wheel_fitments[wheelFitmentIndex].f_wheels.matches[i]}"}}`
                                                    }
                                                }
                                                if (shopifyConfig.upsell.monsterOnly) {
                                                    if (stringFilters == '') {
                                                        stringFilters = `{productVendor:"MONSTER"}`
                                                    } else {
                                                        stringFilters = `${stringFilters},{productVendor:"MONSTER"}`
                                                    }
                                                }
                                                let queryString = {
                                                    query: `{
                                                collection(handle:"${shopifyConfig.wheelsCollection}") {
                        	                        products(first:5, sortKey:BEST_SELLING, filters:[${stringFilters}]) {
		                                                edges {
			                                                node {
                		        		                        id
				                                                handle
				                                                title
                				                                images(first:1) {
				                	                                edges {
						                                                node {
        							                                        url
                        							                        altText
				                        		                        }
					                                                }
                				                                }
				                                                variants (first:1) {
					                                                edges {
						                                                node {
                							                                id
        				                			                        price {
		        						                                        amount
				        			                                        }
                                                						}
				                        	                        }
				                                                }
                                        		        	}
        		                                        }
                        	                        }   
                                                }
                                            }`
                                                }
                                                const options = {
                                                    method: 'POST',
                                                    headers: {
                                                        'Content-Type': 'application/json',
                                                        'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                                                    },
                                                    body: JSON.stringify(queryString)
                                                };
                                                try {
                                                    const getWheels = await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options);
                                                    const wheels = await getWheels.json();
                                                    if (storeSelector.nearestStore) {
                                                        if (wheels?.data?.collection?.products?.edges) {
                                                            for (let i = 0; i < wheels.data.collection.products.edges.length; i++) {
                                                                let stockData = await stockStore.requestStock([wheels.data.collection.products.edges[i].node.id.replaceAll('gid://shopify/Product/', '')], [storeSelector.nearestStore.node.id.replaceAll('gid://shopify/Location/', '')], 4, false)
                                                                if (stockData[0]?.locations[0]?.available == 'Y') {
                                                                    if (upsellProduct?.value?.findIndex(val => val?.variantGid == wheels?.data?.collection?.products?.edges[i]?.node?.variants?.edges[0]?.node?.id) == -1) {
                                                                        let wheelTitle = wheels?.data?.collection?.products?.edges[i]?.node?.title || ""
                                                                        if (wheelTitle.includes('|')) {
                                                                            wheelTitle = wheelTitle.split('|');
                                                                        } else {
                                                                            wheelTitle = [wheelTitle]
                                                                        }
                                                                        upsellProduct.value.push({
                                                                            title: wheelTitle,
                                                                            url: `${shopifyConfig.storeURL}/products/${wheels?.data?.collection?.products?.edges[i]?.node?.handle}` || "",
                                                                            variantGid: wheels?.data?.collection?.products?.edges[i]?.node?.variants?.edges[0]?.node?.id || "",
                                                                            price: promoStore.priceFormat(wheels?.data?.collection?.products?.edges[i]?.node?.variants?.edges[0]?.node?.price?.amount) || "",
                                                                            imageUrl: wheels?.data?.collection?.products?.edges[i]?.node?.images?.edges[0]?.node?.url || "",
                                                                            imageAltText: wheels?.data?.collection?.products?.edges[i]?.node?.images?.edges[0]?.node?.altText || "",
                                                                            alignment: false
                                                                        })
                                                                        upsellAdded.value.push(false);
                                                                        rejectWA.value.push(false);
                                                                        mobileUpsellClosed.value.push(false);
                                                                        upsellLoading.value.push(false);
                                                                        noStoreTooltip.value.push(false);
                                                                        alignmentVideoOpen.value.push(false);
                                                                        break;
                                                                    } else {
                                                                        break;
                                                                    }
                                                                }
                                                            }
                                                            return;
                                                        }
                                                    }
                                                } catch (error) {
                                                    console.log('Error fetching wheel alignment', error)
                                                    return {
                                                        "error": error
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    syncWheelAlignmentUpsellVisibility();
                } catch (error) {
                    console.log(error)
                }
            };

            const syncWheelAlignmentUpsellVisibility = () => {
                const cartVariantIds = new Set(
                    (cartTools?.cartContent?.lines?.edges || [])
                        .map(edge => edge?.node?.merchandise?.id)
                        .filter(Boolean)
                );

                for (let i = 0; i < upsellProduct.value.length; i++) {
                    if (!upsellProduct.value[i]?.alignment) continue;
                    const variantGid = upsellProduct.value[i]?.variantGid;
                    const inCart = !!(variantGid && cartVariantIds.has(variantGid));
                    upsellAdded.value[i] = inCart;
                    if (inCart) {
                        mobileUpsellClosed.value[i] = true;
                    }
                }
            };

            const addUpsellToCart = async (idx) => {
                const wa = upsellProduct.value[idx];
                if (!wa?.variantGid || upsellAdded.value[idx] || upsellLoading.value[idx]) return;

                if (!storeSelector.nearestStore) {
                    noStoreTooltip.value[idx] = true;
                    setTimeout(() => { noStoreTooltip.value[idx] = false; }, 3000);
                    return;
                }

                const cartId = cartContentValue.value?.id || JSON.parse(localStorage.getItem('cartData') || '{}')?.id;
                const variantId = String(wa.variantGid).replace('gid://shopify/ProductVariant/', '');

                if (!variantId) return;

                upsellLoading.value[idx] = true;
                const qty = upsellProduct.value[idx].alignment ? 1 : 4;
                let cartResponse;

                try {
                    if (!cartId) {
                        const vehicles = JSON.parse(localStorage.getItem('vehicles') || '[]');
                        await cartTools.newCart(variantId, qty, vehicles, storeSelector.location, false);
                        cartResponse = 'ok';
                    } else if (upsellProduct.value[idx].alignment) {
                        cartResponse = await cartTools.cartAdd(variantId, 1, cartId);
                    } else {
                        cartResponse = await cartTools.cartAdd(variantId, 4, cartId);
                    }
                } finally {
                    upsellLoading.value[idx] = false;
                }
                if (cartResponse == 'cartFull') {
                    rejectWA.value[idx] = true;
                } else {
                    upsellAdded.value[idx] = true;
                    if (upsellProduct.value[idx]?.alignment) {
                        mobileUpsellClosed.value[idx] = true;
                    }
                    await checkCartStock();
                }
            };

            const dismissMobileUpsell = (idx) => {
                if (typeof idx !== 'number' || idx < 0) return;
                mobileUpsellClosed.value[idx] = true;
            };

            const hasHiddenMobileUpsell = Vue.computed(() =>
                upsellProduct.value.some((upsell, index) =>
                    upsell?.alignment && !upsellAdded.value[index] && mobileUpsellClosed.value[index]
                )
            );
            const mobileUpsellOpen = Vue.computed(() =>
                upsellProduct.value.some((upsell, index) =>
                    upsell?.alignment && !upsellAdded.value[index] && !mobileUpsellClosed.value[index]
                )
            );

            const reopenMobileUpsell = () => {
                for (let i = 0; i < upsellProduct.value.length; i++) {
                    if (upsellProduct.value[i]?.alignment) {
                        mobileUpsellClosed.value[i] = false;
                    }
                }
            };

            Vue.watch(
                () => cartTools.pending,
                (isPending) => {
                    if (!isPending) {
                        if (stockRecheckTimer) clearTimeout(stockRecheckTimer);
                        stockRecheckTimer = setTimeout(async () => {
                            if (cartTools.showCart) {
                                await checkCartStock();
                            }
                            cartUpdating.value = false;
                            priceUpdatePending.value = false;
                            lastUpdatedLineId.value = null;
                        }, 300);
                    }
                }
            );

            const normalizeFitmentDate = (date) => {
                if (!date) {
                    if (cartTools.fitmentDate !== '') cartTools.fitmentDate = '';
                    cartTools.fitmentTime = '';
                    return;
                }
                if (!/^\d{4}-\d{2}-\d{2}$/.test(String(date))) {
                    cartTools.fitmentDate = '';
                    cartTools.fitmentTime = '';
                    return;
                }
                const minDate = minFitmentDate.value;
                if (date < minDate) {
                    cartTools.fitmentDate = minDate;
                    cartTools.fitmentTime = '';
                    return;
                }
                const d = new Date(date + 'T00:00:00');
                if (d.getDay() === 0) {
                    cartTools.fitmentDate = '';
                    cartTools.fitmentTime = '';
                    return;
                }
                if (isSelectedStoreBlockedDate(date)) {
                    cartTools.fitmentDate = '';
                    cartTools.fitmentTime = '';
                    return;
                }
                if (cartTools.fitmentTime) {
                    const minForDate = fitmentTimeMin.value;
                    const maxForDate = getFitmentTimeMaxForDate(date);
                    if (cartTools.fitmentTime < minForDate) cartTools.fitmentTime = minForDate;
                    if (cartTools.fitmentTime > maxForDate) cartTools.fitmentTime = maxForDate;
                }
            };

            let fitmentDatePicker = null;
            let fitmentTimePicker = null;
            let isSyncingPickers = false;
            const toLocalDateFromISO = (isoDate) => {
                if (!isoDate || !/^\d{4}-\d{2}-\d{2}$/.test(String(isoDate))) return null;
                const [y, m, d] = String(isoDate).split('-').map(Number);
                return new Date(y, m - 1, d, 0, 0, 0, 0);
            };

            const syncFitmentPickers = () => {
                if (!fitmentDatePicker || !fitmentTimePicker) return;

                const minDateForPicker = minFitmentDate.value || toLocalISODate();
                fitmentDatePicker.set('minDate', toLocalDateFromISO(minDateForPicker) || minDateForPicker);

                const selectedDate = cartTools.fitmentDate || '';
                const selectedTime = cartTools.fitmentTime || '';

                if (selectedDate) {
                    if (fitmentDatePicker.input.value !== selectedDate) {
                        fitmentDatePicker.setDate(selectedDate, false, 'Y-m-d');
                    }
                } else if (fitmentDatePicker.input.value) {
                    fitmentDatePicker.clear();
                }

                const disableTime = !selectedDate || isFitmentDateSunday.value;
                const minTimeForDate = fitmentTimeMin.value;
                const maxTimeForDate = getFitmentTimeMaxForDate(selectedDate);
                fitmentTimePicker.set('minTime', minTimeForDate);
                fitmentTimePicker.set('maxTime', maxTimeForDate);
                fitmentTimePicker.input.disabled = disableTime;
                if (disableTime) {
                    if (fitmentTimePicker.input.value) fitmentTimePicker.clear();
                } else if (selectedTime && fitmentTimePicker.input.value !== selectedTime) {
                    fitmentTimePicker.setDate(selectedTime, false, 'H:i');
                }
            };

            const initFitmentPickers = () => {
                if (fitmentDatePicker || !window.flatpickr) return;

                const dateInput = document.getElementById('precheck-date');
                const timeInput = document.getElementById('precheck-time');
                if (!dateInput || !timeInput) return;

                if (!validDatePattern.test(String(dateInput.value || ''))) {
                    dateInput.value = '';
                }
                if (!validTimePattern.test(String(timeInput.value || ''))) {
                    timeInput.value = '';
                }

                fitmentDatePicker = window.flatpickr(dateInput, {
                    dateFormat: 'Y-m-d',
                    disableMobile: true,
                    allowInput: false,
                    // static (not appendTo) keeps the calendar in #cartTarget's
                    // promoted top-layer subtree by inserting it right next to
                    // the input via plain CSS instead of moving it elsewhere in
                    // the DOM. appendTo made flatpickr compute the calendar's
                    // position with its default document-relative math (input
                    // rect + page scroll offset) - wrong once the append target
                    // is #cartTarget's own position:fixed, inset:0 box, which
                    // doesn't scroll with the page at all: the calendar
                    // rendered far below the input (worse the more the page had
                    // been scrolled) and never moved back into view. static
                    // positions it with real CSS relative to the input itself,
                    // so it's always correctly placed and scrolls naturally
                    // with .preCheckContent - no JS position math at all.
                    static: true,
                    minDate: toLocalDateFromISO(minFitmentDate.value || toLocalISODate()),
                    disable: [
                        (date) => {
                            const day = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
                            const minDay = toLocalDateFromISO(minFitmentDate.value || toLocalISODate());
                            const iso = `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, '0')}-${String(day.getDate()).padStart(2, '0')}`;

                            if (minDay && day < minDay) {
                                return true;
                            }
                            if (day.getDay() === 0) {
                                return true;
                            }
                            if (isSelectedStoreBlockedDate(iso)) {
                                return true;
                            }
                            return false;
                        }
                    ],
                    onChange: (_, dateStr) => {
                        isSyncingPickers = true;
                        cartTools.fitmentDate = dateStr || '';
                        normalizeFitmentDate(cartTools.fitmentDate);
                        isSyncingPickers = false;
                        syncFitmentPickers();
                    }
                });
                fitmentDatePicker.calendarContainer?.addEventListener('touchmove', e => { e.preventDefault(); e.stopPropagation(); }, { passive: false });

                fitmentTimePicker = window.flatpickr(timeInput, {
                    enableTime: true,
                    noCalendar: true,
                    dateFormat: 'H:i',
                    disableMobile: true,
                    time_24hr: true,
                    minuteIncrement: 30,
                    allowInput: false,
                    static: true,
                    minTime: fitmentTimeMin.value,
                    maxTime: currentFitmentTimeMax.value,
                    onChange: (_, timeStr) => {
                        isSyncingPickers = true;
                        cartTools.fitmentTime = timeStr || '';
                        if (cartTools.fitmentTime && cartTools.fitmentDate && !isFitmentDateSunday.value) {
                            const minForDate = fitmentTimeMin.value;
                            const maxForDate = getFitmentTimeMaxForDate(cartTools.fitmentDate);
                            if (cartTools.fitmentTime < minForDate) cartTools.fitmentTime = minForDate;
                            if (cartTools.fitmentTime > maxForDate) cartTools.fitmentTime = maxForDate;
                        }
                        isSyncingPickers = false;
                        syncFitmentPickers();
                    }
                });
                fitmentTimePicker.calendarContainer?.addEventListener('touchmove', e => { e.preventDefault(); e.stopPropagation(); }, { passive: false });

                syncFitmentPickers();
            };

            Vue.watch(
                () => cartTools.fitmentDate,
                (date) => {
                    normalizeFitmentDate(date);
                    if (!isSyncingPickers) syncFitmentPickers();
                }
            );

            Vue.watch(
                () => cartTools.fitmentTime,
                (time) => {
                    if (!time || !cartTools.fitmentDate || isFitmentDateSunday.value) return;
                    const minForDate = fitmentTimeMin.value;
                    const maxForDate = getFitmentTimeMaxForDate(cartTools.fitmentDate);
                    if (time < minForDate) cartTools.fitmentTime = minForDate;
                    if (time > maxForDate) cartTools.fitmentTime = maxForDate;
                    if (!isSyncingPickers) syncFitmentPickers();
                }
            );
            sanitizeFitmentValues();
            normalizeFitmentDate(cartTools.fitmentDate);

            Vue.watch(
                () => minFitmentDate.value,
                () => {
                    normalizeFitmentDate(cartTools.fitmentDate);
                    initFitmentPickers();
                    syncFitmentPickers();
                }
            );

            Vue.watch(
                () => isSelectedStoreClosed.value,
                () => {
                    normalizeFitmentDate(cartTools.fitmentDate);
                    initFitmentPickers();
                    syncFitmentPickers();
                }
            );

            Vue.nextTick(() => {
                const tryInitPickers = () => {
                    if (window.flatpickr && document.getElementById('precheck-date') && document.getElementById('precheck-time')) {
                        initFitmentPickers();
                        return;
                    }
                    setTimeout(tryInitPickers, 100);
                };
                tryInitPickers();
            });

            const getStoredVehicles = () => {
                try {
                    const raw = localStorage.getItem('vehicles');
                    return raw ? JSON.parse(raw) : [];
                } catch (e) {
                    return [];
                }
            };

            const buildVehicleMakeModel = (vehicle) => {
                if (!vehicle) return '';
                if (vehicle?.name) return String(vehicle.name).trim();
                const make = vehicle?.make?.display_name || '';
                const model = vehicle?.model?.display_name || '';
                const variant = vehicle?.display_name || '';
                return `${make} ${model} ${variant}`.trim();
            };

            const getActiveVehicle = () => {
                const activeVehicleId = localStorage.getItem('activeVehicleId');
                if (!activeVehicleId) return null;

                const liveVehicles = Array.isArray(vehicleSearch?.vehicles) ? vehicleSearch.vehicles : [];
                const liveMatch = liveVehicles.find((v) => String(v?.id) === String(activeVehicleId));
                if (liveMatch) return liveMatch;

                const storedVehicles = getStoredVehicles();
                return storedVehicles.find((v) => String(v?.id) === String(activeVehicleId)) || null;
            };

            const syncCheckoutVehicleDetails = () => {
                const activeVehicle = getActiveVehicle();
                if (!activeVehicle) {
                    cartTools.vehicleLPN = '';
                    cartTools.vehicleState = '';
                    cartTools.vehicleMakeModel = '';
                    return;
                }

                const rego = String(activeVehicle?.rego || vehicleSearch?.regoLPN || '').trim();
                const regoState = String(activeVehicle?.regoState || vehicleSearch?.regoState || '').trim();
                const makeModel = buildVehicleMakeModel(activeVehicle);

                if (rego) cartTools.vehicleLPN = rego;
                if (regoState) cartTools.vehicleState = regoState;
                if (makeModel) cartTools.vehicleMakeModel = makeModel;
            };

            // Keep rego/state fallback from vehicle search store
            if (vehicleSearch.regoLPN) cartTools.vehicleLPN = vehicleSearch.regoLPN;
            if (vehicleSearch.regoState) cartTools.vehicleState = vehicleSearch.regoState;
            syncCheckoutVehicleDetails();

            Vue.watch(() => vehicleSearch.regoLPN, (v) => {
                if (!localStorage.getItem('activeVehicleId')) {
                    cartTools.vehicleLPN = v;
                }
            });
            Vue.watch(() => vehicleSearch.regoState, (v) => {
                if (!localStorage.getItem('activeVehicleId')) {
                    cartTools.vehicleState = v;
                }
            });
            Vue.watch(() => vehicleSearch.vehicles, () => {
                syncCheckoutVehicleDetails();
            }, { deep: true });

            window.addEventListener('vehicle-updated', () => {
                syncCheckoutVehicleDetails();
            });
            window.addEventListener('storage', (e) => {
                if (e.key === 'activeVehicleId' || e.key === 'vehicles') {
                    syncCheckoutVehicleDetails();
                }
            });

            Vue.watch(upsellKey, () => {
                loadUpsellProduct();
            });

            loadUpsellProduct();

            Vue.watch(
                () => (cartTools?.cartContent?.lines?.edges || [])
                    .map(edge => edge?.node?.merchandise?.id || '')
                    .join('|'),
                () => {
                    syncWheelAlignmentUpsellVisibility();
                },
                { immediate: true }
            );

            Vue.watch(
                [
                    () => cartTools.vehicleLPN,
                    () => cartTools.vehicleState,
                    () => cartTools.vehicleMakeModel,
                    () => cartTools.storeNotes,
                    () => cartTools.fitmentDate,
                    () => cartTools.fitmentTime,
                    () => cartTools.confirmTyreWheelSize,
                    () => cartTools.confirmStockTerms,
                ],
                () => {
                    cartTools.validateCheckout?.();
                    localStorage.setItem(
                        'checkoutDetails',
                        JSON.stringify({
                            vehicleLPN: cartTools.vehicleLPN,
                            vehicleState: cartTools.vehicleState,
                            vehicleMakeModel: cartTools.vehicleMakeModel,
                            storeNotes: cartTools.storeNotes,
                            fitmentDate: cartTools.fitmentDate,
                            fitmentTime: cartTools.fitmentTime,
                            confirmTyreWheelSize: cartTools.confirmTyreWheelSize,
                            confirmStockTerms: cartTools.confirmStockTerms,
                        })
                    );
                },
                { deep: true }
            );

            cartTools.validateCheckout?.();

            const cartLRSet = async (cartID, lrID) => {
                if (localStorage.getItem('lr_attribute_set') === 'true') return;
                let queryJSON = {
                    query: `mutation cartAttributesUpdate($attributes: [AttributeInput!]!, $cartId: ID!) {
                        cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {
                            cart {
                                attribute(key:"logrocket") {
                                    value
                                }
                            }
                            userErrors {
                                field
                                message
                            }
                            warnings {
                                code
                            }
                        }
                    }`,
                    variables: {
                        "attributes": [
                            {
                                "key": "logrocket",
                                "value": lrID
                            }
                        ],
                        "cartId": cartID
                    }
                }
                let queryString = JSON.stringify(queryJSON);
                const options = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': shopifyConfig.PLP
                    },
                    body: queryString
                };
                try {
                    let cartResponse = await fetch(`${shopifyConfig.storeURL}/api/${shopifyConfig.apiVersion}/graphql.json`, options)
                    let cartResponseJSON = await cartResponse.json()
                    if (cartResponseJSON?.data?.cartAttributesUpdate?.cart?.attributes?.findIndex(att => att.key == 'logrocket') > -1) {
                        localStorage.setItem('lr_attribute_set', 'true')
                    }
                } catch (e) {
                    localStorage.setItem('lr_attribute_set', 'false')
                    throw new Error(`Error submitting LogRocket ID: ${e}`)
                }
            }

            if (!window.name || window.name.substring(0, 2) !== 'GG') {
                const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                window.name =
                    'GG' + Array.from({ length: 12 }, () => chars.charAt(Math.floor(Math.random() * chars.length))).join('');
            }
            if (shopifyConfig.storeURL.includes('bobjane-prod') || shopifyConfig.storeURL.includes('bobjane.com.au')) {
                if (typeof LogRocket != 'undefined') {
                    try {
                        LogRocket.getSessionURL((url) => {
                            localStorage.setItem('lrs', url.split('?')[0]);
                            if (cartTools.cartData.id || localStorage.getItem('cartData')) {
                                let cartID = cartTools.cartData.id || JSON.parse(localStorage.getItem('cartData')).id || false;
                                if (cartID && !cartContent?.value?.attribute?.value) {
                                    cartLRSet(cartID, url.split('?')[0])
                                }
                            }
                        });
                    } catch (e) {
                        console.error(`Logrocket error: ${e}`)
                    }
                }
            }

            const parseCurrency = (val) => {
                if (typeof val === 'number') return val;
                if (typeof val === 'string') return Number(val.replaceAll('$', '').replaceAll(',', '')) || 0;
                return 0;
            };

            const preDiscountTotal = Vue.computed(() => {
                if (!Array.isArray(cartLinesFiltered.value) || cartLinesFiltered.value.length === 0) return false;
                const sum = cartLinesFiltered.value.reduce((acc, line) => {
                    const lineTotal = parseCurrency(line?.node?.totalPrice);
                    if (!isFitmentFeeLine(line)) return acc + lineTotal;

                    const fitmentUnitPrice = Number(line?.node?.merchandise?.price?.amount || 0);
                    const fitmentQty = Number(line?.node?.quantity || 0);
                    const fitmentTotal = fitmentUnitPrice > 0 ? fitmentUnitPrice * fitmentQty : lineTotal;
                    return acc + (lineTotal - fitmentTotal);
                }, 0);
                return sum > 0 ? cartFormat(sum) : false;
            })

            const total = Vue.computed(() => {
                if (!Array.isArray(cartLinesFiltered.value) || cartLinesFiltered.value.length === 0) return false;
                const sum = cartLinesFiltered.value.reduce((acc, line) => acc + parseCurrency(line?.node?.discountPrice), 0);
                return sum > 0 ? cartFormat(sum) : false;
            })

            const discount = Vue.computed(() => {
                const pre = parseCurrency(preDiscountTotal.value);
                const post = parseCurrency(total.value);
                const saved = pre - post;
                return saved > 0 ? cartFormat(saved) : false;
            });

            Vue.watch(earliestFitmentDate, (newFitmentDate) => {
                if (newFitmentDate) {
                    const triggerEvent = (trackingObject) => {
                        if (typeof LogRocket != 'undefined') {
                            LogRocket.track('cartLeadTime', trackingObject);
                        }
                        if (typeof dataLayer != 'undefined') {
                            dataLayer.push({
                                'event': 'cartLeadTime',
                                'store': trackingObject?.store || null,
                                'leadDays': trackingObject?.leadDays || null,
                                'skus': trackingObject?.skus || []
                            });
                        }
                        localStorage.setItem('leadTimeObj', JSON.stringify(trackingObject));
                    }

                    const leadDays = (Date.parse(new Date(newFitmentDate)) - Date.parse(new Date().toISOString().split('T')[0])) / (24 * 60 * 60 * 1000)
                    if (!isNaN(leadDays) && cartContentValue.value?.lines?.edges.length > 0 && storeSelector.nearestStore) {
                        let skus = cartContentValue.value?.lines?.edges?.flatMap((edge) => {
                            if (edge?.node?.merchandise?.sku) {
                                return edge.node.merchandise.sku;
                            } else {
                                return [];
                            }
                        })
                        let leadTimeTrackObject = {
                            store: storeSelector?.nearestStore?.node?.name || null,
                            leadDays: leadDays || null,
                            skus: skus || null
                        }
                        if (localStorage.getItem('leadTimeObj')) {
                            if (localStorage.getItem('leadTimeObj') != JSON.stringify(leadTimeTrackObject)) {
                                triggerEvent(leadTimeTrackObject);
                            }
                        } else {
                            triggerEvent(leadTimeTrackObject);
                        }
                    }
                }
            })

            return {
                cartTools,
                cartContentValue,
                cartLinesFiltered,
                linePromo,
                isLinePriceUpdating,
                handleQtyChange,
                removeLine,
                canRemoveLine,
                isFitmentRemovalLocked,
                upsellProduct,
                addUpsellToCart,
                dismissMobileUpsell,
                mobileUpsellClosed,
                hasHiddenMobileUpsell,
                mobileUpsellOpen,
                reopenMobileUpsell,
                selectedStoreName,
                isFitmentFeeLine,
                lineStockStatus,
                bestAlternativeStore,
                hasOutOfStockLines,
                switchCartStore,
                enquireAll,
                cartUpdating,
                earliestFitmentDate,
                minFitmentDate,
                isFitmentDateSunday,
                isFitmentDateSaturday,
                isSelectedStoreClosed,
                selectedStoreClosedToDisplay,
                showWheelFreightNotice,
                fitmentTimeMin,
                fitmentTimeMax,
                currentFitmentTimeMax,
                fitmentTimeRangeLabel,
                upsellAdded,
                rejectWA,
                upsellLoading,
                noStoreTooltip,
                alignmentVideoOpen,
                toggleAlignmentVideo,
                getUpsellDescBubble,
                discount,
                total,
                preDiscountTotal,
                genericStorageResult,
                showOrderPlacedBanner,
                dismissOrderPlacedBanner,
                fittingValid,
                isWheel,
                freeArray
            };
        },
    });
    cart.use(window.VueAppGlobals.pinia);
    cart.mount('#cartTarget');
}

if (window.Vue && window.Pinia) {
    vueCart();
} else {
    window.addEventListener('vue-ready', vueCart);
}
